import React from 'react';
import classnames from 'classnames';
import HiddenIcon from '@wix/da-ds/pkg/Icons/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';
import { DumboProps as Props } from '../types';

import s from './Hidden.scss';

const HiddenDumbView: React.FC<Props> = ({ className, width, height }) => {
  const canShowHugeIcon = Math.min(width ?? Infinity, height ?? Infinity) > 48;

  return (
    <Flex
      className={classnames(s['root'], className)}
      justifyContent="center"
      alignItems="center"
      style={{
        width: width || height,
        height: height || width,
      }}
    >
      <HiddenIcon size={canShowHugeIcon ? IconSize.HUGE : IconSize.SMALL} />
    </Flex>
  );
};
HiddenDumbView.displayName = 'HiddenDumbView';

export default HiddenDumbView;
